var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.document.isFavorite===false)?_c('v-icon',[_vm._v("mdi-star-outline")]):_vm._e(),(_vm.document.isFavorite===true)?_c('v-icon',[_vm._v("mdi-star")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }